var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event_owner_MVP-2_desktop",
    transform: "translate(-1085.000000, -158.000000)",
    fill: "#10CCC6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1064.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9999785,158.531287 C34.8163733,158.531287 38.7187078,162.433621 38.7187078,167.250016 C38.7187078,172.066411 34.8163733,175.968745 29.9999785,175.968745 C25.1835838,175.968745 21.2812493,172.066411 21.2812493,167.250016 C21.2812493,162.433621 25.1835838,158.531287 29.9999785,158.531287 Z M29.9999785,174.281249 C33.8847349,174.281249 37.0312118,171.134772 37.0312118,167.250016 C37.0312118,163.36526 33.8847349,160.218783 29.9999785,160.218783 C26.1152222,160.218783 22.9687453,163.36526 22.9687453,167.250016 C22.9687453,171.134772 26.1152222,174.281249 29.9999785,174.281249 Z M32.1726227,170.610932 L29.1878848,168.441824 C29.0788801,168.360937 29.0156059,168.234389 29.0156059,168.100802 L29.0156059,162.328153 C29.0156059,162.096136 29.2054629,161.906279 29.4374799,161.906279 L30.5624772,161.906279 C30.7944942,161.906279 30.9843512,162.096136 30.9843512,162.328153 L30.9843512,167.309788 L33.3327762,169.018364 C33.5226333,169.155487 33.5612913,169.419158 33.4242029,169.608981 L32.7632395,170.51954 C32.626151,170.70586 32.3624798,170.748055 32.1726227,170.610932 Z",
    id: "\\uF017"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGreen);
export default __webpack_public_path__ + "static/media/clock-green.14338250.svg";
export { ForwardRef as ReactComponent };